// extracted by mini-css-extract-plugin
export default {"mobile":"834px","tablet":"835px","desktop":"1440px","avatar":"Avatar_avatar__qbz0B","avatar-hover":"Avatar_avatar-hover__I9WvP","initials":"Avatar_initials__eEAlY"};